const localStorageUtil = {
  setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },

  getItem(key) {
    const value = localStorage.getItem(key);
    try {
      return value ? JSON.parse(value) : null;
    } catch (e) {
      console.error(`Failed to parse localStorage "${key}"`, e);
      return null;
    }
  },

  removeItem(key) {
    localStorage.removeItem(key);
  },

  clear() {
    localStorage.clear();
  },

  updateItemField(key, field, newValue) {
    const obj = this.getItem(key) || {};
    obj[field] = newValue;
    this.setItem(key, obj);
  },

  getItemField(key, field) {
    const obj = this.getItem(key);
    return obj?.[field];
  },
};

export default localStorageUtil;
